/* globals $ window MutationObserver */
// TODO: make MutationObserver service, and mock browser api for testing
// TODO: remove jquery for native, or use angular element/jQlite ( which kinda sucks )
const fd2 = require('./findDom2.js')() // TODO: all-static or factory(doc) like fd

export default [
  '$rootScope',
  'tabService',
  'findReplaceService',
  '$element',
  '$timeout',
  FindReplaceCtrl,
]

export function FindReplaceCtrl(
  $rootScope,
  tabService,
  findReplaceService,
  $element,
  $timeout
) {
  this.toFind = ''
  this.toReplace = ''
  this.matchCase = false

  this.seqIndex = 0
  this.seqSize = 0

  const isNgHidden = (str) => `${str}`.match(/ng-hide( |$)/gm) !== null

  const observeShow = (fn) => (el) => {
    if (!(el && el.tagName)) {
      console.warn('tried to observe a non-element')
      return
    }

    // todo: make this a registerable service
    let mo = new MutationObserver((mus) =>
      mus.forEach((mu) => {
        // detect transition from hidden to shown
        let wasHidden = isNgHidden(mu.oldValue)
        let isHidden = isNgHidden(el.getAttribute('class'))
        if (wasHidden && !isHidden) {
          fn(mu)
        }
      })
    )

    mo.observe(el, {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'],
    })
    return mo
  }

  this.show = () => {
    this.visible = true
    this.clear()
  }

  this.hide = () => {
    this.clear()
    this.visible = false
  }

  this.$postLink = () => {
    this.findTextInput = $element.find('.findText')
    let outerDiv = $element.children()[0]
    let focus = () => this.findTextInput.focus()
    observeShow(focus)(outerDiv)
  }

  this.clear = () => {
    this.toFind = ''
    this.toReplace = ''
    this.reset()
  }

  this.reset = () => {
    ;[
      ...document.querySelectorAll('[content-element] [contenteditablebind]'),
    ].forEach(fd2.removeMarks)
    this.seqSize = 0
    this.seqIndex = 0
    this.updateHighlight()
  }

  this.findAll = (index = 0) => {
    // index allows resuming, prev, next, wrap
    // if empty, do nothing
    if (!this.toFind.length) return

    this.reset()
    let findex = 0 // count of total results and sequential index for prev, next
    const searchable = [
      ...document.querySelectorAll('[content-element] [contenteditablebind]'),
    ]
    searchable.forEach((elem) => {
      let result = fd2.find(elem, this.toFind, this.matchCase)
      if (result.matchRanges.length) {
        // we do some things below in reverse to ensure clean dom inserts
        // so we need to be clever with findex ordering as a result.
        let localFindex = (findex = findex + result.matchRanges.length) - 1
        result.matchRanges.reverse().forEach((rng) => {
          fd2.highlight(rng, { 'data-findex': localFindex-- })
        })
      }
    })
    this.seqSize = findex // accurate after last incrment
    this.seqIndex = index % this.seqSize
    this.updateHighlight()
  }

  this.replaceAll = () => {
    if (this.toReplace && this.toReplace.length) {
      let els = [...$(`mark.el-find-result[data-findex]`)]
      const ceb = $(els).closest('[contenteditablebind]')
      els.forEach((el) => {
        var txt = document.createTextNode(this.toReplace)
        el.parentNode.replaceChild(txt, el)
      })
      ceb
        .trigger('update')
        .closest('[content-element]')
        .addClass('dirty')
    }
    this.findAll()
  }

  this.replace = (index) => {
    if (this.toReplace && this.toReplace.length) {
      let el0 = $(`mark.el-find-result[data-findex="${index}"]`)[0]
      if (el0) {
        const $contentElementWithReplaceChange = $(el0.parentNode)

        var txt = document.createTextNode(this.toReplace)
        el0.parentNode.replaceChild(txt, el0)

        $contentElementWithReplaceChange
          .trigger('update')
          .closest('[content-element]')
          .addClass('dirty')
      }
    }
    this.findAll(index)
  }

  this.next = (i = this.seqIndex || 0, n = this.seqSize || 0) => {
    this.seqIndex = (i + 1) % n
    this.updateHighlight()
  }

  this.prev = (i = this.seqIndex || 0, n = this.seqSize || 0) => {
    this.seqIndex = (i + n - 1) % n
    this.updateHighlight()
  }

  // todo: move to a find-dom fn?
  this.updateHighlight = () => {
    $(`mark.el-find-result`).removeClass('active')
    let el = $(`mark.el-find-result[data-findex="${this.seqIndex}"]`)
    el.addClass('active')
    if (el[0]) {
      el[0].scrollIntoView(true)
    }
  }

  this.keyhandler = (e) => {
    if (e.key === 'Enter' && this.findAll.length) {
      if (this.seqSize === 0) {
        this.findAll()
      } else {
        this.next()
      }
    }
    return true
  }

  $rootScope.$on('FIND_AND_REPLACE', (info, action) => {
    if (action.type === 'TERMINATE') {
      this.hide()
    }
  })

  // TODO: ~awt #true-components pass in message names, maybe?
  $rootScope.$on('TOGGLE_FIND_REPLACE', (info) => {
    if (this.visible) {
      this.hide()
    } else {
      this.show()
    }
  })

  $rootScope.$on('BEFORE_SAVE', (e) => {
    this.clear()
  })
}
